<div class="page">

  <div class="pagehead">
    <div>
      <h1>Useful links</h1>
      <p>Government portals and bank services your customers ask about — each opens in a new tab</p>
    </div>
  </div>

  <div class="links" *ngIf="data && data.length">
    <div class="card card--hover link" *ngFor="let i of data" (click)="links(i.url)" role="link" tabindex="0"
      (keydown.enter)="links(i.url)">
      <span class="logo-chip"><img [src]="logoFor(i.url)" [alt]="i.title"
        (error)="$any($event.target).src = 'assets/links/_link.svg'"></span>
      <span class="link-title">{{ i.title }}</span>
      <span class="link-open">Open ↗</span>
    </div>
  </div>

  <div class="links" *ngIf="!data">
    <div class="card link" *ngFor="let i of [1,2,3,4,5,6]">
      <div class="er-skel er-skel--card logo-skel"></div>
      <div class="er-skel er-skel--text title-skel"></div>
    </div>
  </div>

  <div class="card page-empty" *ngIf="data && !data.length">
    <span class="t">No links right now</span>
    Check back later — links appear here as they're published.
  </div>

</div>
